import axios from "axios";
import React, { useEffect, useState } from "react";
import Layout from "../../components/user/Layout";
import authManager from "../../utils/authManager";
import toast from "react-hot-toast";


const Idcard = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const user = authManager.getUserProfile();

  useEffect(() => {
    const token = authManager.getAccessToken();

    const fetchPDF = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}id-card/${user.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/pdf",
            },
            responseType: "blob",
          }
        );

        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfUrl(fileURL);
      } catch (error) {
        toast.error("Failed to load PDF!");
        console.error("Error fetching PDF:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchPDF();
    }
  }, [user?.id]);

  return (
    <Layout>
      <div className="w-full h-screen flex items-center justify-center">
        {loading ? (
          <div className="flex flex-col items-center space-y-3">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-600">Loading you id card...</p>
          </div>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="Member PDF"
            className="w-full h-full border-none"
          />
        ) : (
          <p className="text-red-600">No PDF available.</p>
        )}
      </div>
    </Layout>
  );
};

export default Idcard;
